export default __webpack_public_path__ + "static/media/portfolio-hover-197.92feea22.jpg";